import { ButtonHTMLAttributes, ReactNode } from "react"
import clsx from "clsx"

const Button = ({
  className,
  appearance = "primary",
  disabled = false,
  children,
  ...rest
}: {
  className?: string
  appearance?: "primary" | "secondary"
  disabled?: boolean
  children: ReactNode
  rest?: ButtonHTMLAttributes<HTMLButtonElement>
}) => {
  const classes = clsx(
    "h-10 w-full rounded px-4 text-base font-bold disabled:opacity-50",
    className,
    {
      "hover:bg-teal-450 active:bg-teal-550 bg-teal-500 text-white":
        appearance === "primary",
      "bg-white text-gray-900 active:bg-gray-100": appearance === "secondary",
    }
  )

  return (
    <button className={classes} disabled={disabled} {...rest}>
      {children}
    </button>
  )
}

export default Button
